import React, { useState } from 'react';

import T from 'utils/useLocalizer';
import { IOrderCustomStatusFormData } from 'models/ordersModel';
import { CircleFill, Pencil, Trash } from 'react-bootstrap-icons';
import ConfirmModal from 'components/ui/modal/confirmModal/ConfirmModal';
import AddCustomStatusModal from './AddCustomStatusModal';
import Tooltip from 'components/ui/tooltip/CustomTooltip';

export interface Props {
  item: IOrderCustomStatusFormData;
  onEdit: (data: IOrderCustomStatusFormData) => any;
  onDelete: (id: number) => any;
}

const CustomStatusListItem = ({ item, onEdit, onDelete }: Props) => {
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const resources = {
    notifyOnLabel: T('orders.order.settings.custom.status.table.notify.on.label'),
    notifyOffLabel: T('orders.order.settings.custom.status.table.notify.off.label'),
    confirmDeleteTitle: T('orders.order.settings.custom.status.delete.confirmation.title'),
    confirmDeleteMessage: T('orders.order.settings.custom.status.delete.confirmation.message'),
  };

  const editStatusHandler = (data: IOrderCustomStatusFormData) => {
    onEdit(data);
    setShowEditModal(false);
  };
  return (
    <>
      <tr className="f-s-14 px-2" key={item.itemId}>
        <td className="bg-white" data-tooltip-id={`status-name-${item.itemId}`}>
          <span className="badge bg-light-blue p-2 rounded-pill text-xs truncate-width-200">
            <CircleFill width={7} height={6} /> {item.name}
          </span>
        </td>
        <td className="p-3 bg-white">{item.isNotify ? resources.notifyOnLabel : resources.notifyOffLabel}</td>
        <td className="p-3 bg-white">{item.templateName ? item.templateName : '_'}</td>
        <td className="text-muted p-3 bg-white d-flex justify-content-center">
          <button className="btn py-1 px-2 border-0" type="button" onClick={() => setShowEditModal(true)}>
            <Pencil />
          </button>
          <button className="btn py-1 px-2 border-0" type="button" onClick={() => setShowDeleteModal(true)} disabled={!!item.isUsed}>
            <Trash />
          </button>
        </td>
      </tr>
      <Tooltip id={`status-name-${item.itemId}`} children={item.name} />

      {showEditModal && (
        <AddCustomStatusModal mode="edit" show={showEditModal} onClose={() => setShowEditModal(false)} item={item} onSubmit={editStatusHandler} />
      )}
      {showDeleteModal && !item.isUsed && (
        <ConfirmModal
          show={showDeleteModal}
          confirmHandler={() => onDelete(item.itemId)}
          closeHandler={() => setShowDeleteModal(false)}
          title={resources.confirmDeleteTitle}
          message={resources.confirmDeleteMessage}
        />
      )}
    </>
  );
};

export default CustomStatusListItem;
